
import { css } from 'lit';
export default css`
/* Apply CSS Variables to the host element. */
:host{
  --sic-featured-content-hero--default--spacing:var(--spacing-08);
  --sic-featured-content-hero--default--heading-size:var(
    --headline-06-font-size
  );
  --sic-featured-content-hero--default--heading-line-height:var(
    --headline-06-line-height
  );
}
`;